import React from 'react';

var _ref2 = /*#__PURE__*/React.createElement("span", null, "/");

var TUXTextFieldHeader = function TUXTextFieldHeader(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      hasCounter = _ref.hasCounter,
      length = _ref.length,
      maxLength = _ref.maxLength,
      shouldHighlightCounter = _ref.shouldHighlightCounter;
  var shouldShowCounter = hasCounter !== undefined && hasCounter === true && maxLength !== undefined && maxLength > 0;
  var shouldShowSubtitle = subtitle !== undefined && subtitle.length > 0;
  return /*#__PURE__*/React.createElement("header", {
    className: "flex flex-col pt-16 pb-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "H4-SemiBold text-color-TextPrimary"
  }, title), shouldShowCounter ? /*#__PURE__*/React.createElement("div", {
    className: "flex H4-Regular text-color-TextTertiary"
  }, /*#__PURE__*/React.createElement("span", {
    className: shouldHighlightCounter ? 'text-color-Negative' : ""
  }, length), _ref2, /*#__PURE__*/React.createElement("span", null, maxLength)) : null), shouldShowSubtitle ? /*#__PURE__*/React.createElement("div", {
    className: "P2-Regular text-color-TextTertiary mt-6"
  }, subtitle) : null);
};

export { TUXTextFieldHeader };
//# sourceMappingURL=TUXTextFieldHeader.js.map
